import React from 'react';

import NukaCarousel, { ICarouselProps } from '@r1-frontend/ui-react/components/NukaCarousel';

const HeaderCarousel: React.FC<ICarouselProps> = ({ children }) => {
    return (
        <NukaCarousel
            withoutArrows
            withoutControls
            withoutDots
            autoplay
            wrapAround
            vertical
            style={{
                textAlign: 'center',
            }}
        >
            {children}
        </NukaCarousel>
    );
};

export default HeaderCarousel;
